import FFieldMDP from "../form/field/FFieldMDP";
import FTextFieldMDP from "../form/field/FTextFieldMDP";
import MDP from "../MDP";
import FCellTextMDP from "./cell/FCellTextMDP";
import FColumnCellMDP from "./FColumnCellMDP";
import { DataType, ICustomSort } from "./FDataTableMDP";

export default class FColumnMDP implements MDP {
   
    label: string;
    dataSelectorKey: string | undefined;
    align: string = "left";
    sortable?: boolean;
    columnCellMDP?: FColumnCellMDP;
    hidden: boolean;
    width?: string;
    enableCopy?: boolean;
    dataSelectorKeyToCopy?: string;
    copyTooltipText?: string;
    enableGroupBy?: boolean;
    enableTotal?: boolean;
    hiddenInCardView?: boolean;
    onSort?: (sortOptions?: ICustomSort) => void;
    infoFieldMDPType?: any;
    dataType?: DataType;

    constructor(props: {
        label: string;
        dataSelectorKey?: string ;
        align?: string;
        sortable?: boolean;
        columnCellMDP?: FColumnCellMDP;
        hidden?: boolean;
        width?: string
        enableCopy?: boolean;
        dataSelectorKeyToCopy?: string;
        copyTooltipText?: string;
        enableGroupBy?: boolean;
        enableTotal?: boolean;
        hiddenInCardView?: boolean;
        onSort?: (sortOptions?: ICustomSort) => void;
        infoFieldMDPType?: any;
        dataType?: DataType;
    }) {
        this.label = props.label;
        this.dataSelectorKey = props.dataSelectorKey;
        this.align = props.align||"left";
        this.sortable = props.sortable || true;
        this.hidden = props.hidden || false;
        this.columnCellMDP = props.columnCellMDP || new FCellTextMDP({dataSelectorKey: this.dataSelectorKey});
        this.width = props.width;
        this.enableCopy = props.enableCopy;
        this.enableGroupBy = props.enableGroupBy;
        this.dataSelectorKeyToCopy = props.dataSelectorKeyToCopy;
        this.copyTooltipText = props.copyTooltipText;
        this.enableTotal = props.enableTotal;
        this.hiddenInCardView = props.hiddenInCardView || false;
        this.onSort = props.onSort;
        this.infoFieldMDPType = props.infoFieldMDPType || FTextFieldMDP;
        this.dataType = props.dataType || DataType.String;
    }

    getMetaData(): object {
        return {
            text: this.label,
            value: this.dataSelectorKey,
            columnCellMetaData: this.columnCellMDP?.getMetaData(),
            align:this.align,
            sortable: this.sortable,
            hidden: this.hidden,
            width: this.width,
            enableCopy: this.enableCopy,
            enableGroupBy: this.enableGroupBy,
            copyTooltipText: this.copyTooltipText,
            dataSelectorKeyToCopy: this.dataSelectorKeyToCopy,
            enableTotal: this.enableTotal,
            hiddenInCardView: this.hiddenInCardView,
            onSort: this.onSort,
            infoFieldMDPType: this.infoFieldMDPType,
            dataType:this.dataType
        }
    }
}


